// @codekit-prepend "src/slick.min.js", "src/lity.min.js";
const counterUp = window.counterUp.default
let players = [];

$(document).ready(function() {
	if($('.menu-item-has-children a').length) {
		$('.menu-item-has-children a').click(function(e) {
			if($(e.target).hasClass('toggle')) {
				e.preventDefault();
				e.stopPropagation();

				if($(e.target).hasClass('active')) {
					$('.toggle').removeClass('active');
					$(this).parent().find('.sub-menu').css('max-height', '0px');

					return false;
				}

				$('.toggle').removeClass('active');
				$(this).find('.toggle').toggleClass('active');
				$('.sub-menu').removeClass('active');
				$('.sub-menu').css('max-height', '0px');
				$(this).parent().find('.sub-menu').toggleClass('active');

				if($(this).parent().find('.sub-menu').hasClass('active')) {
					let totalHeight = 0;
					// set the max height based on the total height of the li

					$(this).parent().find('.sub-menu li').each(function() {
						totalHeight += $(this).outerHeight(true);
					})
					$(this).parent().find('.sub-menu').css('max-height', totalHeight + 'px');
				} else {
					$(this).parent().find('.sub-menu').css('max-height', '0px');
				}
			}
		});
	}

	if($('.accordion__player,.full-width-video__player').length) {
		$('.accordion__player,.full-width-video__player').each(function() {
			const parent = $(this).parent();


			let options = {
			}

			// jank
			if(parent.hasClass('collection-content__video') || parent.hasClass('accordion__gallery-video')) {
				const index = parent.data('video-id');

				options = {
					controls: false,
					loop: { active: true },
					resetOnEnd: true,
					quality: { default: 1080 }
				}

				const player = new Plyr(this,options);
				let videoPlaying = player.playing;

				// get the iframe's thumbnail


				player.on('ready', event => {
					player.volume = 0;
					player.autoplay = false;
					player.muted = true;

					// if(player.paused) {
					// 	setTimeout(() => {
					// 		player.play();
					// 	}, 0);
					// }

					$('.plyr__controls').click(function() {
						player.fullscreen.exit();
					})

				});


				player.on('playing', event => {

					if(!videoPlaying) {
						parent.find('.accordion__gallery-poster').hide();
						videoPlaying = true;
					}
				});


				player.on('ended', event => {
					if(player.paused) {
						player.play();
					}
				});

				$(document).on('lity:ready', function(event, instance) {
					if(!player.paused) {
						player.pause();
					}
				});


				$(document).on('lity:close', function(event, instance) {
					if(player.paused) {
						// setTimeout(function() {
						// player.play();
						// },0)
					}
				});

				if($(parent).find('a').length) {
					$(parent).find('a').click(function(e) {
						if(window.innerWidth < 1024) {
							e.preventDefault();
							e.stopPropagation();

							// player go to full screen
							player.fullscreen.enter();
							player.muted = false;
							player.volume = 1;
							player.play();
						}
					});
				}



				player.on('exitfullscreen', event => {
					if(window.innerWidth < 1024) {
						player.stop();
						player.restart();

					}
				});

				players.push({index: index, player: player});


			} else {
				const player = new Plyr(this, options);
			}


		})
	}


	if($('.hero__player').length) {
		const player = new Plyr('.hero__player', {
			controls: false,
			loop: { active: true },
			resetOnEnd: true,
			quality: { default: 1080 }
		});

		player.on('ready', event => {
			player.volume = 0;
			player.autoplay = true;
			player.muted = true;
			if(player.paused) {
				setTimeout(function() {
					player.play();
				},0)
			}
		});

		// incase it doesn't loop..
		player.on('ended', event => {
			if(player.paused) {
				setTimeout(function() {
					player.play();
				},0)
			}
		});
	}


	$('a[href*="#"]').not('[data-lity]').not('[href="#appraisal-form"]').not('[href="#property-form"]').not('[href="#vacate-form"]').not('[href="#maintenance-form"]').click(function(e) {
		if($.attr(this, 'href').indexOf('popup-') > -1) {
			// console.log($.attr(this, 'href'))
			$($.attr(this, 'href')).addClass('active');
			return false;
		}

		const href = $.attr(this, 'href');
		const hashIndex = href.indexOf('#');

		if (hashIndex > -1) {
			const hash = href.slice(hashIndex);
			const slugIndex = href.indexOf('/');


			if (slugIndex > -1) {
				const hashWithoutSlug = hash.slice(slugIndex);

				const $hashElement = $(hashWithoutSlug);
				const windowHeight = $(window).height();
				const headerHeight = $('header').outerHeight();
				const hashElementHeight = $hashElement.outerHeight();

				let scrollTo = window.innerWidth >= 1024 ? $hashElement.offset().top - (windowHeight - hashElementHeight) / 2 : $hashElement.offset().top - headerHeight;

				if(hashElementHeight > windowHeight - headerHeight) {
					scrollTo = $hashElement.offset().top - headerHeight;
				}


				$('html, body').animate(
					{
						scrollTop: scrollTo
					},
					1200
				);


			} else {
				const $hashElement = $(hash);
				const windowHeight = $(window).height();
				const headerHeight = $('header').outerHeight();
				const hashElementHeight = $hashElement.outerHeight();
				let scrollTo = $(hash).offset().top - $('header').outerHeight() - (windowHeight - hashElementHeight) / 2;

				if(hashElementHeight > windowHeight - headerHeight) {
					scrollTo = $(hash).offset().top - $('header').outerHeight();
				}
				$('html, body').animate(
					{
						scrollTop: window.innerWidth >= 1024 ? scrollTo : $(hash).offset().top - $('header').outerHeight()
					},
					1200
				);
			}
			return false;
		}


	});

	// find anchor tags that have the string '?scrollto='
	$('a[href*="?scrollto="]').click(function() {
		if(('#' + $.attr(this, 'href')).length) {
			$('html, body').animate(
				{
					scrollTop: $('#' + $.attr(this, 'href').split('?scrollto=')[1]).offset().top - $('header').outerHeight()
				},
				1200
				);


			setTimeout(() => {
				ScrollTrigger.refresh();
			}, 0);
			return false;
		}
	});

	$('.header__burger,.nav .sub-menu a,.nav .sub-menu li a').click(function() {
		$('.nav,.nav-bg,header,.header__burger').toggleClass('active');
	})

	$('.nav-bg').click(function(e) {
		$('.nav-bg,.nav,.header__burger,header').removeClass('active');
	})




	// * Header/Nav scroll animation
	const headerTl = gsap.timeline({
		paused: true,
		reverse: false,
		scrollTrigger: {
			trigger: 'body',
			start: 'top+=15px top',
			end: 'bottom-=15px bottom', // never ending.
			toggleActions: 'play pause resume reverse',
			onEnter: () => {
				$('header').addClass('scrolled');
			},
			onLeaveBack: () => {
				setTimeout(() => {
					$('header').removeClass('scrolled');
				}, 200);
			}
		}
	});

	headerTl
		.to('.header__logo', {
			x: '-150%',
			ease: 'Power1.easeIn',
			duration: 1
		})
		.to('.header__logo', {
			opacity: 0,
			ease: 'ease-in',
			duration: 0.8
		},0)
		.to('.header__motif', {
			opacity: 1,
			duration: 1
		},0.75);



	// $(window).scroll(function() {
	// 	if($(window).scrollTop() > 15) {
	// 		$('header').addClass('scrolled');
	// 		headerTl.play();

	// 	} else {
	// 		headerTl.reverse();
	// 		$('header').removeClass('scrolled');

	// 	}
	// });

	let initAlmLoad = false;
	if($('section.collection').length) {
		window.almComplete = function(alm){
			let numOfPosts = alm.posts;
			ScrollTrigger.refresh();


			if(getCookie('currentFilter') && initAlmLoad === false) {
				const currentFilter = getCookie('currentFilter');
				const currentTime = new Date().getTime();
				const currentStatus = currentFilter.split('_')[0];
				const creationTime = currentFilter.split('_')[1];
				const timeDiff = currentTime - creationTime;

				if(timeDiff < 5000) {
					$(`.alm-filter--link[data-value="${currentStatus}"]`).trigger('click');

					$('html, body').animate({
						scrollTop: $('.collection__projects').offset().top - $('header').outerHeight()
					},1200);


					setTimeout(() => {
						if (!gup('status')) {
							const currentUrl = window.location.href;
							const newUrl = currentUrl + `?status=${currentStatus}`;
							history.pushState({}, "", newUrl);
						}
					}, 3000);

				}

				initAlmLoad = true;
			}


			if($('#gform_submit_button_4').length) {
				$('#gform_submit_button_4').click(function(e) {
					const currentFilter = gup('status');
					eraseCookie('currentFilter');
					setCookie('currentFilter', `${currentFilter}_${new Date().getTime()}`, 1);
				})
			}

			if(numOfPosts > 0) {
				$('.collection__projects-project').off('mouseenter mouseleave');
				$('.collection__projects-image').off('mouseenter mouseleave');

				$('.collection__projects-project').each(function() {
					const _this = $(this);
					if($(this).find('.collections__projects-video').children().length === 0 && !$(this).find('.collections__projects-video').is('video')) {
						$(this).find('.collections__projects-video').each(function() {

							const player = new Plyr(this, {
								ratio: '1061:1200',
								muted: true,
								controls: false,
								volume: 0,
								quality: { default: 1080 }
							});

							player.on('ready', event => {
								_this.find('.collection__projects-image').hover(function() {

									if(player.paused) {
										setTimeout(function() {
											player.play();
										},0)
									}
								}, function() {
									if(!player.paused) {
										player.stop();
									}
								})
							});
						})

					} else {
						$(this).find('.collection__projects-image').hover(function() {
							const video = $(this).find('video')[0];
							if(video) {
								video.play();
							}
						}, function() {
							const video = $(this).find('video')[0];
							if(video) {
								video.pause();
								video.currentTime = 0;
							}
						})
					}
				});
			} else {

			}


		};

	}

	// * Scroll Gallery
	// TODO: SCROLL ANIMATIONS
	if($('.scroll-gallery').length) {
		// $('.scroll-gallery .swiper-slide').each(function() {
		// 	$(this).attr('data-swiper-parallax-y', -window.innerHeight);
		// });

		if(window.innerWidth >= 1024) {
			gsap.to('.scroll-gallery', {
				scrollTrigger: {
					trigger: '.scroll-gallery',
					scrub: 1,
					pin: true,
					snap: 1 / ($('.scroll-gallery .swiper-slide').length - 1),
					end: () => "+=" + $('.scroll-gallery').height() * 0.2
				}
			});
		}

		$('.scroll-gallery').each(function() {
			const _this = $(this);
			const scrollGallery = $(this).find('.scroll-gallery__images');
			let settings = {
				speed: 1300,
				parallax: true,
				on: {
					slideChange: function() {
						setTimeout(function () {
							swiper.params.mousewheel.releaseOnEdges = false;
						}, 600);
					},
					reachBeginning: function() {
						setTimeout(function () {
							swiper.params.mousewheel.releaseOnEdges = true;
						}, 720);
					},
					reachEnd: function() {
							setTimeout(function () {
								swiper.params.mousewheel.releaseOnEdges = true;
							}, 720);
					}
				},
				mousewheel: {
					eventsTarget: _this.find('.scroll-gallery__container')[0],
					releaseOnEdges: false,
				},
				effect: "creative",
				creativeEffect: {
					prev: {
						translate: [0, "-50%", -1],
					},
					next: {
						translate: [0, "100%", 0],
					},
				},
			}

			if(window.innerWidth < 1024) {
				settings = {
					autoplay: true,
					delay: 3000,
					loop: true,
					navigation: {
						prevEl: _this.find('.scroll-gallery__arrows-left')[0],
						nextEl:  _this.find('.scroll-gallery__arrows-right')[0],
					},
				}
			}

			const swiper = new Swiper(scrollGallery[0], settings);

			swiper.on('slideChange', function () {
				const activeIndex = swiper.activeIndex;
				const activeSlide = swiper.slides[activeIndex];
				const activeHeader = _this.find(`.scroll-gallery__title[data-index="${$(activeSlide).data('index')}"]`);
				const activeHref = $(activeSlide).find('a').attr('href');

				$('.scroll-gallery__title').removeClass('active');
				activeHeader.addClass('active');


				// _this.find('.scroll-gallery__link').attr('href', activeHref);
			});

			swiper.on('scroll', function () {
				if($(window).scrollTop() !== _this.offset().top) {
					$('html, body').animate({
						scrollTop: _this.offset().top
					}, 1200);
				}
			});


			// gsap.set(".ball", {xPercent: -50, yPercent: -50});

			// const cursor = document.querySelectorAll('.scroll-gallery__cursor');
			let mouse = {x: 0, y: 0};
			// const speed = 0.2;
			// const pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
			// const xSet = gsap.quickSetter(cursor, "x", "px");
			// const ySet = gsap.quickSetter(cursor, "y", "px");

			_this.find('.scroll-gallery__images').mousemove(e => {
				mouse.x = getCursorPos(e,_this.find('.scroll-gallery__images')).x;
				mouse.y = getCursorPos(e,_this.find('.scroll-gallery__images')).y;

				gsap.to('.scroll-gallery__cursor span', {
					duration: 0.25,
					overwrite: "auto",
					x: mouse.x,
					y: mouse.y,
					stagger: 0.08,
					ease: "power2.out"
				})

			});

			// gsap.ticker.add(() => {
			// 	const dt = 1.0 - Math.pow(1.0 - speed, gsap.ticker.deltaRatio());

			// 	pos.x += (mouse.x - pos.x) * dt;
			// 	pos.y += (mouse.y - pos.y) * dt;
			// 	xSet(pos.x);
			// 	ySet(pos.y);
			// });


		});

		// const scrollGalleries = gsap.utils.toArray('.scroll-gallery');

		// scrollGalleries.forEach((scrollGallery, i) => {
		// 	const slides = gsap.utils.toArray('.scroll-gallery__images:not(:last-child) img', scrollGallery);

		// 	const sliderTl = gsap.timeline({
		// 		paused: true,
		// 		scrollTrigger: {
		// 			trigger: scrollGallery,
		// 			start: `top top`,
		// 			end: `bottom+=${slides.length * window.innerHeight / 0.8} bottom`,
		// 			pin: true,
		// 			markers: true,
		// 			scrub: true
		// 		}
		// 	});

		// 	// slides.forEach((slide, i) => {
		// 	// 	const slideTl = gsap.timeline({
		// 	// 		paused: true,
		// 	// 		scrollTrigger: {
		// 	// 			trigger: scrollGallery,
		// 	// 			start: `top top`,
		// 	// 			end: `bottom bottom`,
		// 	// 			pin: true,
		// 	// 			markers: true,
		// 	// 			scrub: true
		// 	// 		}
		// 	// 	});

		// 	// });
		// });


	}



	if($('.timeline').length) {
		const slideCount = $('.timeline__slide').length;

		$('.timeline__gallery').slick({
			slidesToShow: 2,
			slidesToScroll: 1,
			arrows: false,
			draggable: false,
			dots: false,
			asNavFor: '.timeline__headings',
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 1
					}
				}
			]
		});

		$('.timeline__gallery').click(function(e) {
			if(e.pageX > $(this).offset().left + $(this).width() / 2) {
				$('.timeline__arrow svg:last-child').trigger('click');
			}
		})

		$('.timeline__gallery').on('afterChange', function(event, slick, currentSlide, nextSlide){
			const slideWidth = $('.timeline__gallery .slick-current').width();
			$('.timeline__descriptions').css('max-width', slideWidth);

			$('.timeline__timeline-year').removeClass('active');
			$('.timeline__timeline-year').eq(currentSlide).addClass('active');
			$('.timeline__descriptions').slick('slickGoTo', currentSlide);
			$('.timeline__arrow svg:first-child').addClass('active');
		});



		$(window).resize(function() {
			const slideWidth = $('.timeline__gallery .slick-current').width();
			$('.timeline__descriptions').css('max-width', slideWidth);
		});

		$('.timeline__headings').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			fade: true,
			arrows: false,
			draggable: false,
			dots: false,
			asNavFor: '.timeline__gallery'
		});

		$('.timeline__descriptions').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			fade: true,
			arrows: false,
			draggable: false,
			dots: false,
			adaptiveHeight: true
		});

		let reversing = false;

		$('.timeline__arrow svg:first-child').click(function() {
			$('.timeline__gallery').slick('slickPrev');
			$('.timeline__descriptions').slick('slickPrev');

			const currentIndex = $('.timeline__gallery').slick('slickCurrentSlide');
			$('.timeline__timeline-year').removeClass('active');
			$('.timeline__timeline-year').eq(currentIndex).addClass('active');
		});

		$('.timeline__arrow svg:last-child').click(function() {
			$('.timeline__gallery').slick('slickNext');
			$('.timeline__descriptions').slick('slickNext');

			const currentIndex = $('.timeline__gallery').slick('slickCurrentSlide');
			$('.timeline__timeline-year').removeClass('active');
			$('.timeline__timeline-year').eq(currentIndex).addClass('active');

			$('.timeline__arrow svg:first-child').addClass('active');
		});

		$('.timeline__timeline-year').click(function() {
			const index = $(this).data('index');
			$('.timeline__timeline-year').removeClass('active');
			$(this).addClass('active');
			$('.timeline__gallery').slick('slickGoTo', index);
			$('.timeline__descriptions').slick('slickGoTo', index);

			$('.timeline__arrow svg:first-child').addClass('active');
		});

		// $('.timeline__gallery').on('afterChange', function(event, slick, currentSlide, nextSlide) {
		// 	if(currentSlide === slideCount - 1) {
		// 		$('.timeline__arrow').addClass('reverse');
		// 		reversing = true;
		// 	}


		// 	if(currentSlide === 0) {
		// 		$('.timeline__arrow').removeClass('reverse');
		// 		reversing = false;
		// 	}
		// });

	}


	// if($('.accordion__gallery').length) {
	// 	$('.accordion__gallery').slick({
	// 		slidesToShow: 1,
	// 		slidesToScroll: 1,
	// 		arrows: false,
	// 		draggable: false,
	// 		dots: false,
	// 		fade: true
	// 	});



	// 	$('.accordion__accordion-item h3').click(function(e) {
	// 		const index = $(this).parent().data('index');

	// 		if(window.innerWidth < 1024) {
	// 			const contentHeight = $(this).parent().find('.group').outerHeight();
	// 			$('.accordion__accordion-content').css('max-height', 0);

	// 			if($(this).parent().hasClass('active')) {
	// 				$('.accordion__accordion-item').removeClass('active');
	// 			} else {
	// 				$('.accordion__accordion-item').removeClass('active');
	// 				$(this).parent().find('.accordion__accordion-content').css('max-height', contentHeight);
	// 				$(this).parent().addClass('active');
	// 			}

	// 		} else {
	// 			$('.accordion__accordion-item').removeClass('active');
	// 			$('.accordion__gallery').slick('slickGoTo', index);
	// 			$(this).parent().addClass('active');


	// 			const { player } = players.find(player => player['index'] === index) || { player: null }

	// 			if(player !== null) {
	// 				if(player.paused) {
	// 					setTimeout(() => {
	// 						player.play();
	// 					}, 0);
	// 				}
	// 			}
	// 		}
	// 	});




	// 	setTimeout(() => {
	// 		$('.accordion__accordion-item:first-child h3').trigger('click');
	// 	}, 500);


	// 	$(window).resize(function() {
	// 		const accordionTextHeight = $('.accordion__text').outerHeight(true);
	// 		const doc = document.documentElement;

	// 		doc.style.setProperty('--offset-height', `${accordionTextHeight}px`);
	// 	}).resize();


	// }

	if($('.accordion__gallery').length) {
		$('.accordion__gallery').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			draggable: false,
			dots: false,
			fade: true
		});

		$('.accordion__media').slick({
			slidesToScroll: 1,
			arrows: false,
			draggable: false,
			dots: false,
			fade: true
		});

		$('.accordion').each(function() {
			const _this = $(this);
			$(this).find('.accordion__accordion-item:first-child h3').trigger('click');


			$(this).find('.accordion__accordion-item h3').click(function(e) {
				const index = $(this).parent().data('index');
				_this.find('.accordion__accordion-item').removeClass('active');
				_this.find('.accordion__gallery').slick('slickGoTo', index);
				_this.find('.accordion__media').slick('slickGoTo', index);
				$(this).parent().addClass('active');

				if(window.innerWidth < 1024) {
					const contentHeight = $(this).parent().find('.group').outerHeight();
					_this.find('.accordion__accordion-content').css('max-height', 0);
					$(this).next().css('max-height', contentHeight);
				}

				_this.find('.accordion__gallery').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
					if(_this.find('.accordion__gallery .slick-slide').eq(nextSlide).hasClass('no-media')) {
						_this.addClass('dark-text');
					} else {
						_this.removeClass('dark-text');
					}
				});

				// if(window.innerWidth < 1024) {
				// 	const contentHeight = $(this).parent().find('.group').outerHeight();
				// 	$('.accordion__accordion-content').css('max-height', 0);

				// 	if($(this).parent().hasClass('active')) {
				// 		$('.accordion__accordion-item').removeClass('active');
				// 	} else {
				// 		$('.accordion__accordion-item').removeClass('active');
				// 		$(this).parent().find('.accordion__accordion-content').css('max-height', contentHeight);
				// 		$(this).parent().addClass('active');
				// 	}

				// } else {
				// 	$('.accordion__accordion-item').removeClass('active');
				// 	$('.accordion__gallery').slick('slickGoTo', index);
				// 	$('.accordion__media').slick('slickGoTo', index);
				// 	$(this).parent().addClass('active');

				// 	// const { player } = players.find(player => player['index'] === index) || { player: null }

				// 	// if(player !== null) {
				// 	// 	if(player.paused) {
				// 	// 		setTimeout(() => {
				// 	// 			player.play();
				// 	// 		}, 0);
				// 	// 	}
				// 	// }
				// }
			});

		});

		if($('.accordion__gallery .slick-slide.slick-current.slick-active').hasClass('no-media')) {
			$('.accordion').addClass('dark-text');
		} else {
			$('.accordion').removeClass('dark-text');
		}




		setTimeout(() => {
			$('.accordion__accordion-item:first-child h3').trigger('click');
		}, 500);


		$(window).resize(function() {
			$('.accordion').each(function() {
				const accordionTextHeight = $(this).find('.accordion__text').outerHeight(true);
				$(this).find('.accordion__gallery').css('margin-top', accordionTextHeight);
			})

		}).resize();


	}

	if($('.accordion-v2__gallery').length) {
		$('.accordion-v2__gallery').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			draggable: false,
			dots: false,
			fade: true
		});
	}

	if($('.accordion-v2').length) {

		if(window.innerWidth < 1024) {
			$('.accordion-v2__accordion-content').css('max-height', 0);
			$('.accordion-v2__accordion-item.active').removeClass('active');
			// $('.accordion-v2__accordion-item.active .accordion-v2__accordion-content').css('max-height', '100%');
		}

		if(window.innerWidth < 1024) {
			$('.accordion-v2__accordion-content').css('max-height', 0);
			$('.accordion-v2__accordion-item.active .accordion-v2__accordion-content').css('max-height', '100%');
		}

		$('.accordion-v2__accordion-item h3').click(function(e) {
			const index = $(this).parent().data('index');

			if(window.innerWidth < 1024) {
				const contentHeight = $(this).parent().find('.group').outerHeight();
				$('.accordion-v2__accordion-content').css('max-height', 0);

				if($(this).parent().hasClass('active')) {
					$('.accordion-v2__accordion-item').removeClass('active');
				} else {
					$('.accordion-v2__accordion-item').removeClass('active');
					$(this).parent().find('.accordion-v2__accordion-content').css('max-height', contentHeight);
					$(this).parent().addClass('active');
				}

			} else {
				$('.accordion-v2__accordion-item').removeClass('active');
				$('.accordion-v2__gallery').slick('slickGoTo', index);
				$(this).parent().addClass('active');


				const { player } = players.find(player => player['index'] === index) || { player: null }

				if(player !== null) {
					if(player.paused) {
						setTimeout(() => {
							player.play();
						}, 0);
					}
				}
			}
		});
	}



	if($('.news-feed').length && window.innerWidth < 1024) {
		$('.news-feed .mobile-slider').slick({
			arrows: true,
			dots: false,
			prevArrow: $('.news-feed__group img.prev'),
			nextArrow: $('.news-feed__group img.next'),
		});


		$('.news-feed .mobile-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
			$('.news-feed__state-current').text(currentSlide + 1);
		});
	}

	if($('.suburb-feed .mobile-slider').length && window.innerWidth < 1024) {
		$('.suburb-feed .mobile-slider').slick({
			arrows: true,
			dots: false,
			prevArrow: $('.suburb-feed__group img.prev'),
			nextArrow: $('.suburb-feed__group img.next'),
		});

		$('.suburb-feed .mobile-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
			$('.suburb-feed__state-current').text(currentSlide + 1);
		});
	}

	if($('.suburb-feed .suburb-feed__slider').length) {
		$('.suburb-feed .suburb-feed__slider').slick({
			arrows: true,
			dots: false,
			slidesToShow: 4,
			prevArrow: $('.suburb-feed__group img.prev'),
			nextArrow: $('.suburb-feed__group img.next'),
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 1,
					}
				}
			]
		});

		$('.suburb-feed__group img.next').click(function(e) {
			$('.suburb-feed__group img').css('opacity', 1);
		});

		$('.suburb-feed__arrow,.suburb-feed__link.arrow img:last-child').click(function(e) {
			e.preventDefault();

			$('.suburb-feed .suburb-feed__slider').slick('slickNext');
		});

		$('.suburb-feed__arrow,.suburb-feed__link.arrow img:first-child').click(function(e) {
			e.preventDefault();

			$('.suburb-feed .suburb-feed__slider').slick('slickPrev');
		});

		$('.suburb-feed .suburb-feed__slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
			$('.suburb-feed__state-current').text(currentSlide + 1);
		})
	}

	if($('.awards__list').length) {
		const slideCount = $('.awards__list-column').length;
		let currentCount = 0;
		$('.awards__list').slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			infinite: true,
			arrows: false,
			dots: false,
			draggable: true,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2
					}
				}
			]
		});

		$('.awards__list').on('afterChange', function(event, slick, currentSlide, nextSlide) {
			$('.awards__arrow svg:first-child').addClass('active');
		});

		// let reversing = false;

		$('.awards__arrow svg:first-child').click(function() {
			$('.awards__list').slick('slickPrev');
			// if(window.innerWidth >= 1024) {
			// 	if(!reversing) {
			// 		$('.awards__list').slick('slickNext');
			// 	} else {
			// 	}


			// } else {
			// 	if(currentCount < slideCount - 2) {
			// 		$('.awards__list').slick('slickNext');
			// 		currentCount++;

			// 	} else {
			// 		$('.awards__list').slick('slickGoTo', 0);
			// 		currentCount = 0;
			// 	}
			// }
		});

		$('.awards__arrow svg:last-child').click(function() {
			$('.awards__list').slick('slickNext');
			// if(window.innerWidth >= 1024) {

			// } else {
			// 	if(currentCount < slideCount - 2) {
			// 		$('.awards__list').slick('slickNext');
			// 		currentCount++;

			// 	} else {
			// 		$('.awards__list').slick('slickGoTo', 0);
			// 		currentCount = 0;
			// 	}
			// }

			$('.awards__arrow svg:first-child').addClass('active');
		})

		// $('.awards__list').on('afterChange', function(event, slick, currentSlide, nextSlide) {
		// 	if(window.innerWidth >= 1024) {
		// 		if(currentSlide === slideCount - 3) {
		// 			$('.awards__arrow').addClass('reverse');
		// 			reversing = true;
		// 		}

		// 		if(currentSlide === 0) {
		// 			$('.awards__arrow').removeClass('reverse');
		// 			reversing = false;
		// 		}
		// 	}

		// });
	}



	if($('.share__link--copy').length) {
		$('.share__link--copy').click(function() {
			const text = $(this).data('clipboard-text');
			window.prompt("Copy to clipboard: Ctrl+C, Enter", text);
		});
	}

	if($('.news-post__gallery-images').length) {
		$('.news-post__gallery-images').slick({
			arrows: true,
			dots: false,
			slidesToShow: 1.5,
			infinite: true,
			centerMode: true,
			// variableWidth: true,

		})
	}

	if($('.page-navigation').length) {
		const sections = gsap.utils.toArray('section:not(.hero)');
		sections.forEach((section, i) => {
			ScrollTrigger.create({
				trigger: section,
				start: 'top top',
				end: 'top top',
				onUpdate: self => {
					const index = self.isActive ? self.trigger.id : self.trigger.previousElementSibling.id;
					if(index.length) {
						$('.page-navigation__links-link').removeClass('active');
						$(`.page-navigation__links-link[data-link="#${index}"]`).addClass('active');
					}
				}
			});

		});

	}

	if($('.staff').length) {
		// if querystring "staff" is present, open the staff modal
		const urlParams = new URLSearchParams(window.location.search);
		const staffId = urlParams.get('staff-id');

		if(staffId) {
			const target = '.staff';
			$(`.staff__grid-item[data-id="${staffId}"]`).click();

			if ($(target).length) {
				if ($(target).height() > $(window).height() - $('header').outerHeight()) {
					$('html, body').animate({
						scrollTop: $(target).offset().top - $('header').outerHeight()
					}, 700, 'swing', function () {});
				} else {
					$('html, body').animate({
						scrollTop: window.innerWidth >= 1024 ? $(target).offset().top - ((window.innerHeight - $(target).outerHeight()) / 2) : $(target).offset().top - $('header').outerHeight()
					}, 700, 'swing', function () {});
				}
			}

		}
		$('.staff__grid').isotope({
			itemSelector: '.grid-item',
			percentPosition: true,
			masonry: {
				columnWidth: '.grid-sizer',
				gutter: '.gutter-sizer'
			}
		});

		$('.staff__filter-item').click(function() {
			$('.staff__filter-item').removeClass('active');
			$(this).addClass('active');

			const filter = $(this).data('filter');
			$('.staff__grid').isotope({ filter: filter });

			$('.staff__sector').text($(this).text())
		});

		if(window.innerWidth < 1024) {
			$('.staff__filter-selected,.staff__filter-item').click(function() {
				$('.staff__filter-group,.staff__filter-selected').toggleClass('active');
			});

			$('.staff__filter-item').click(function() {
				// get text and change thte selected text
				$('.staff__filter-selected').text($(this).text());

			})

			$(document).click(function(e) {
				if(!$(e.target).closest('.staff__filter-group,.staff__filter-selected').length) {
					$('.staff__filter-group,.staff__filter-selected').removeClass('active');
				}
			});

			$(window).resize(function() {
				const width = $('.staff__filter-group').outerWidth(true);
				$('.staff__filter').css('min-width', width);
			}).resize();

		}

		// $('.staff__grid-item').click(function() {
		// 	const id = $(this).data('id');
		// 	$('.staff__profile').removeClass('active');
		// 	$(`.staff__profile[data-id="${id}"]`).addClass('active');

		// 	const profile = $(`.staff__profile[data-id="${id}"]`);
		// 	const profileOffset = profile.offset().top;

		// 	setTimeout(function() {
		// 		$('html, body').animate({
		// 			scrollTop: profileOffset - $('header').outerHeight(true)
		// 		}, 500);
		// 	},100)
		// });

		$('.staff__profile-close').click(function() {
			$('.lity-close').trigger('click');

			// const gridOffset = $('.staff').offset().top;
			// $('html, body').animate({
			// 	scrollTop: gridOffset - $('header').outerHeight(true)
			// }, 500);
		})
	}

	if($('.map-block').length) {
		const position = $('#map').data('position');
		mapboxgl.accessToken = 'pk.eyJ1IjoiYnJhbmRmb3JtcHJvamVjdHMiLCJhIjoiY2t3bHU3cDR3MDY0YjJvcWo0YnNpdmp4ZiJ9.pb7QU77jfVqc4Rz6k00sJw';
		const map = new mapboxgl.Map({
			container: 'map', // container ID
			style: 'mapbox://styles/brandformprojects/cl39mbj9o000f15pe5hutjfv5', // style URL
			center: position, // starting position [lng, lat]
			zoom: 11.5, // starting zoom
		});


		// add a marker element at position using this SVG
		// create a .marker element
		const marker = document.createElement('div');
		marker.className = 'marker';
		// set html
		marker.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="27.7" height="33.31" viewBox="0 0 27.7 33.31"><defs><style>.a{fill:none;}.b{clip-path:url(#a);}.c{clip-path:url(#b);}.d{clip-path:url(#c);}.e{fill:#fff;}.f{clip-path:url(#d);}.g{clip-path:url(#f);}.h{clip-path:url(#g);}</style><clipPath id="a"><rect class="a" width="27.7" height="26.54"/></clipPath><clipPath id="b"><path class="a" d="M13.46,21.83c-4.2,0-7.62-3.76-7.75-8.45H8.19v-.37H5.71c.05-4.76,3.5-8.61,7.75-8.61s7.7,3.84,7.75,8.61H18.73v.37h2.48c-.12,4.69-3.54,8.45-7.75,8.45m0-17.71a9,9,0,1,0,9,9,9,9,0,0,0-9-9"/></clipPath><clipPath id="c"><rect class="a" width="1600" height="3981" transform="translate(-1095.54 -1473.88)"/></clipPath><clipPath id="d"><path class="a" d="M10.46,9.21v-.1h2.78a4.68,4.68,0,0,1,1.35.18,2.459,2.459,0,0,1,.68.31,1.356,1.356,0,0,1,.72,1.36,1.287,1.287,0,0,1-.66,1,2.886,2.886,0,0,1-.77.37l-.11.03-.02.02.14.03a2.525,2.525,0,0,1,1.43.73,1.544,1.544,0,0,1,.43,1.21,1.749,1.749,0,0,1-1.34,1.58,3.318,3.318,0,0,1-1.08.19H10.43v-.1c.04,0,.07-.02.1-.02a.666.666,0,0,0,.49-.44,1.32,1.32,0,0,0,.06-.39V10.43a2,2,0,0,0-.09-.84.608.608,0,0,0-.23-.22.806.806,0,0,0-.33-.14Zm1.73,6.67a.747.747,0,0,0,.11.02,7.67,7.67,0,0,0,1.27.08,1.7,1.7,0,0,0,.67-.13,1.72,1.72,0,0,0,1-1.03,1.758,1.758,0,0,0,.08-.85,1.405,1.405,0,0,0-.34-.78,2.019,2.019,0,0,0-1.48-.69c-.41-.02-1.29,0-1.32,0v3.38Zm0-3.59a.838.838,0,0,1,.1.02,6.692,6.692,0,0,0,1,.04,1.84,1.84,0,0,0,.41-.04,1.4,1.4,0,0,0,1.14-.97,1.575,1.575,0,0,0,.08-.57,1.281,1.281,0,0,0-.21-.72,1.667,1.667,0,0,0-1.17-.74,6.177,6.177,0,0,0-1.36-.07v3.05Z"/></clipPath><clipPath id="f"><path class="a" d="M14.54,33.31l-4.15-6.92h8.3Z"/></clipPath><clipPath id="g"><rect class="a" width="1600" height="3981" transform="translate(-1094.3 -1474.17)"/></clipPath></defs><g class="b"><rect width="29.7" height="28.54" transform="translate(-1 -1)"/></g><g class="c"><g class="d"><rect class="e" width="20" height="20" transform="translate(3.46 3.12)"/></g></g><g class="f"><g class="d"><rect class="e" width="8.02" height="9" transform="translate(9.46 8.11)"/></g></g><g class="g"><g class="h"><rect width="10.31" height="8.92" transform="translate(9.39 25.39)"/></g></g></svg>';

		// add marker to map
		new mapboxgl.Marker(marker)
			.setLngLat(position)
			.addTo(map);

		map.addControl(new mapboxgl.NavigationControl());
		map.scrollZoom.disable();


	}

	if($('.full-width-accordion').length) {
		$('.full-width-accordion__block-title').click(function() {
			const parent = $(this).parent();
			const content = parent.find('.full-width-accordion__block-content');

			if(parent.hasClass('active')) {
				parent.removeClass('active');
				content.css('height', 0);

			} else {
				parent.addClass('active');
				parent.find('.full-width-accordion__block-content').css('height', content.find('.container-fluid').outerHeight(true));
			}
		});

		$(window).resize(function() {
			$('.full-width-accordion__block.active').each(function() {
				const content = $(this).find('.full-width-accordion__block-content');
				content.css('height', content.find('.container-fluid').outerHeight(true));
			});
		});

	}

	if($('.statistics-list.slider .slider .statistics-list__list').length && window.innerWidth < 1024) {
		$('.statistics-list.slider .statistics-list__list').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			autoplay: true,
			autoplaySpeed: 3500,
			dots: false,
			prevArrow: $('.statistics-list.slider .statistics-list__group .prev'),
			nextArrow: $('.statistics-list.slider .statistics-list__group .next')
		})

		$('.statistics-list.slider .statistics-list__list').on('afterChange', function(event, slick, currentSlide, nextSlide){
			$('.statistics-list.slider .statistics__state-current').text(currentSlide + 1);
		});
	}

	// on file upload input#input_5_12 - change the label name to the file name
	$(document).on('change', '#input_5_12', function() {
		const fileName = $(this).val().split('\\').pop();

		$('#field_5_12 label').text(fileName);
	});


	if($('section.collection').length) {
		almfilters.start();

		if(!gup('status')) {
			$('.collection__filter span.all').addClass('active');
		}

		$('.collection__filter span.all').click(function() {
			almfilters.reset();
		});

		if(window.innerWidth < 1024) {
			$('.collection__filter-list span.selected').click(function() {
				$('.collection__filter-group').show();
				$('.collection__filter-list').addClass('active');
			});

			$('.collection__filter-group span, .collection__filter-group .alm-filter--link').click(function() {
				const text = $(this).text();
				$('.collection__filter-group').hide();
				$('.collection__filter-list span.selected').text(text);
				$('.collection__filter-list').removeClass('active');
			});

			$(document).click(function(e) {
				if(!$(e.target).closest('.collection__filter-group').length && !$(e.target).closest('.collection__filter-list span.selected').length) {
					$('.collection__filter-group').hide();
					$('.collection__filter-list').removeClass('active');
				}
			});

			$(window).resize(function() {
				const width = $('.collection__filter-group').outerWidth(true);
				$('.collection__filter-list').css('min-width', width);
			}).resize();

		}


		$('.alm-filter--link').click(function() {
			$('.collection__filter span.all').removeClass('active');
		});

		$('.collection__filter-list span.all').click(function() {
			$('.collection__filter span.all').addClass('active');
		});
	}

	if($('.single-collection').length) {
		const columns = gsap.utils.toArray('.collection-content__stats-column');
		columns.forEach((column, i) => {
			ScrollTrigger.create({
				trigger: 'section.collection-content',
				start: 'top bottom-=44%',
				end: 'bottom bottom',
				onToggle: self => {
					if(self.isActive) {
						counterUp( $(column).find('h2 span')[0], {
							delay: 20,
							duration: 3500,
						} )
					}
				},
			});
		});
	}

	$(window).on('scroll', function() {
		if($(window).scrollTop() > 15) {
			$('body').addClass('scrolled');
		} else {
			$('body').removeClass('scrolled');
		}
	});

	if($('.property-feed__filter-reset').length) {
		$('.property-feed__filter-reset').click(function(e) {
			e.preventDefault();
			$('.property-feed__filter select').each(function() {
				$(this).val($(this).find('option:first').val());

				$(this).trigger('change');
			});

		});
	}

	if($('.property-feed__property-thumbnail').length) {
		$('.property-feed__property-thumbnail').click(function(e) {
			if(!$(e.target).is('a')) {
				if(e.shiftKey || e.ctrlKey || e.metaKey) {
					window.open($(this).parent().find('.property-feed__property-links a:first').attr('href'), '_blank');
				} else {
					window.location.href = $(this).parent().find('.property-feed__property-links a:first').attr('href');
				}
			}

		})
	}

	if($('.testimonials').length) {
		$('.testimonials__slider').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: false,
			arrows: true,
			dots: false,
			prevArrow: $(this).find('.arrow-left'),
			nextArrow: $(this).find('.arrow-right'),

		});
	}

	if($('.hero__title,.hero-gallery__title').length) {
		if($('.hero').next().hasClass('collection') || $('.hero').next().hasClass('page-navigation')) {
			$('.hero__title').addClass('offset-left container-left');
		}

		if($('.hero').next().hasClass('page-navigation')) {
			$('.hero__title').addClass('large')
		}

		if(!$('body').hasClass('home')) {

			gsap.from('.hero__title,.hero-gallery__title', {
				scrollTrigger: {
					trigger: '.hero,.hero-gallery',
					start: 'top top',
					end: 'bottom-=10% top',
					scrub: true,
					onEnter: function() {;
						$('.hero,.hero-gallery').addClass('scrolled');
					}
				},
				opacity: 1,
			});
		}
	}

	if($('.hero-gallery').length) {
		$('.hero-gallery__slider').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			dots: true,
			arrows: true,
			autoplay: true,
			autoplaySpeed: 5000,
			pauseOnHover: false,
			prevArrow: `<svg class="arrow-left" xmlns="http://www.w3.org/2000/svg" width="8.123" height="16.412" viewBox="0 0 8.123 16.412">
				<path id="Path_1450" data-name="Path 1450" d="M1.151-3.17,8.774,3.574,16.151-3.17" transform="translate(4.246 -0.445) rotate(90)" fill="none" stroke="#000" stroke-linecap="round" stroke-width="1"/>
			</svg>`,
			nextArrow: `<svg class="arrow-right" xmlns="http://www.w3.org/2000/svg" width="8.123" height="16.412" viewBox="0 0 8.123 16.412">
				<path id="Path_1450" data-name="Path 1450" d="M1.151-3.17,8.774,3.574,16.151-3.17" transform="translate(3.877 16.857) rotate(-90)" fill="none" stroke="#000" stroke-linecap="round" stroke-width="1"/>
			</svg>`
		})
	}


	if($('.gallery').length) {
		const $carousel = $('.gallery__gallery');

		$carousel.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			centerMode: true,
			arrows: true,
			infinite: true,
			// autoplay: true,
			variableWidth: true,
			adaptiveHeight: true,
			autoplaySpeed: 5000,
			pauseOnHover: false,
			prevArrow: $(this).find('.gallery__arrows-left'),
			nextArrow: $(this).find('.gallery__arrows-right'),
		});

		$carousel.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
			 var
					 direction,
					 slideCountZeroBased = slick.slideCount - 1;

			 if (nextSlide == currentSlide) {
					 direction = "same";

			 } else if (Math.abs(nextSlide - currentSlide) == 1) {
					 direction = (nextSlide - currentSlide > 0) ? "right" : "left";

			 } else {
					 direction = (nextSlide - currentSlide > 0) ? "left" : "right";
			 }

			 // Add a temp CSS class for the slide animation (.slick-current-clone-animate)
			 if (direction == 'right') {
					 $('.slick-cloned[data-slick-index="' + (nextSlide + slideCountZeroBased + 1) + '"]', $carousel).addClass('slick-current-clone-animate');
			 }

			 if (direction == 'left') {
					 $('.slick-cloned[data-slick-index="' + (nextSlide - slideCountZeroBased - 1) + '"]', $carousel).addClass('slick-current-clone-animate');
			 }
	 });

	 $carousel.on('afterChange', function (event, slick, currentSlide, nextSlide) {
			 $('.slick-current-clone-animate', $carousel).removeClass('slick-current-clone-animate');
			 $('.slick-current-clone-animate', $carousel).removeClass('slick-current-clone-animate');
	 });
	}

	if(gup('scrollto')) {
		if($('#' + gup('scrollto'))) {
			setTimeout(() => {
				$('html, body').animate(
					{
						scrollTop: $('#' + gup('scrollto')).offset().top - $('header').outerHeight()
					},
					1200
				);

				setTimeout(() => {
					ScrollTrigger.refresh();
				}, 1200);
			},1400)
		}
	}

	$('a[href="#maintenance-form"]').click(function(e) {
		e.preventDefault();
		e.stopPropagation();

		$('.maintenance-form').addClass('active');
	});

	$('a[href="#appraisal-form"]').click(function(e) {
		e.preventDefault();
		e.stopPropagation();

		$('.appraisal-form').addClass('active');
	});

	$('a[href="#vacate-form"]').click(function(e) {
		e.preventDefault();
		e.stopPropagation();

		$('.vacate-form').addClass('active');
	});


	$('.appraisal-form__close').click(function() {
		$('.appraisal-form').removeClass('active');
	})

	$('.vacate-form__close').click(function() {
		$('.vacate-form').removeClass('active');
	})


	$('.maintenance-form__close').click(function() {
		$('.maintenance-form').removeClass('active');
	})

	$('.popup-form__close').click(function() {
		$('.popup-form').removeClass('active');
	})

	$(document).click(function(e) {
		if ($('.appraisal-form').hasClass('active')) {
			if (!$(e.target).closest('.appraisal-form__body').length) {
				$('.appraisal-form').removeClass('active');
			}
		}
	});

	$(document).click(function(e) {
		if ($('.vacate-form').hasClass('active')) {
			if (!$(e.target).closest('.vacate-form__body').length) {
				$('.vacate-form').removeClass('active');
			}
		}
	});

	$(document).click(function(e) {
		if ($('.popup-form').hasClass('active')) {
			if (!$(e.target).closest('.popup-form__body').length && !$(e.target).closest('.ui-datepicker')) {
				$('.popup-form').removeClass('active');
			}
		}
	});


	// Repeat...
	$('a[href="#property-form"]').click(function(e) {
		e.preventDefault();
		e.stopPropagation();

		$('.property-form').addClass('active');
	});


	$('.property-form__close').click(function() {
		$('.property-form').removeClass('active');
	})


	$(document).click(function(e) {
		if ($('.property-form').hasClass('active')) {
			if (!$(e.target).closest('.property-form__body').length) {
				$('.property-form').removeClass('active');
			}
		}
	});


	// $(document).click(function(e) {
	// 	if ($('.maintenance-form').hasClass('active')) {
	// 		if (!$(e.target).closest('.maintenance-form__body').length) {
	// 			$('.maintenance-form').removeClass('active');
	// 		}
	// 	}
	// });

	if($('.property-form').length) {
		$(document).on('gform_post_render', function(event, formId) {
			$('.dynamic-address').text($('.page-navigation__title').text());
		});
	}


	// Properties Feed
	let currentStatus = 'Rental';
	let prevStatus = 'Rental';
	$('.property-feed__filter form,.property-feed__filter-mobile form').change(function() {
		const formData = $(this).serializeArray();

		const filteredProperties = $('.property-feed__property').filter(function() {
			const propertyData = $(this).data('data');

			for (let i = 0; i < formData.length; i++) {
				const formValue = formData[i];
				if (formValue.value === 'all') {
					continue;
				}

				if (formValue.name === 'type') {
					if (!propertyData.type.includes(formValue.value)) {
						return false;
					}
				} else if (formValue.name === 'minimum-price') {
					if (parseFloat(propertyData.price.replace(/,/g, '')) < parseFloat(formValue.value.replace(/,/g, ''))) {
						return false;
					}
				} else if (formValue.name === 'maximum-price') {
					if (parseFloat(propertyData.price.replace(/,/g, '')) > parseFloat(formValue.value.replace(/,/g, ''))) {
						return false;
					}
				} else if (formValue.name === 'bed') {
					if (parseInt(propertyData.bed) < parseInt(formValue.value)) {
						return false;
					}
				} else if (formValue.name === 'bath') {
					if (parseInt(propertyData.bath) < parseInt(formValue.value)) {
						return false;
					}
				} else if (formValue.name === 'suburb') {
					if (propertyData.suburb !== formValue.value) {
						return false;
					}
				} else if (formValue.name === 'status') {
					if (propertyData.status !== formValue.value) {
						return false;
					}
				}
			}

			return true;
		});

		$('.property-feed__property').hide();

		filteredProperties.show();

		$('.property-feed__results span').text(filteredProperties.length);

		prevStatus = currentStatus;
		if(window.innerWidth >= 1024) {
			currentStatus = $('.property-feed__filter-status select').val();
		} else {
			currentStatus = $('.property-feed__filter-mobile .property-feed__filter-status select').val();
		}


		if(currentStatus !== prevStatus) {
			sortPrices();
		}
	});

	$('.property-feed__filter form,.property-feed__filter-mobile form').trigger('change');


	// trigger form change
	sortProperties('newest');
	sortPrices();

	$('.property-feed__filter-mobile .more-btn').click(function(e) {
		e.preventDefault();

		$('.accordion-block').toggleClass('active');

		if ($('.accordion-block').hasClass('active')) {
			$(this).text('Less filters');
		} else {
			$(this).text('More filters');
		}

	})

	$('.property-feed__sort select').change(function() {
		const selectedValue = $(this).val();
		sortProperties(selectedValue);
	});

	$('.property-feed__filter-minimum_price select, .property-feed__filter-maximum_price select').each(function() {
		$(this).change(function() {
			const minimumPrice = parseFloat($(this).parent().parent().find('.property-feed__filter-minimum_price select').val().replace(/,/g, ''));
			const maximumPrice = parseFloat($(this).parent().parent().find('.property-feed__filter-maximum_price select').val().replace(/,/g, ''));

			if ($(this).parent().hasClass('property-feed__filter-minimum_price')) {
				$(this).parent().parent().find('.property-feed__filter-maximum_price option').each(function() {
					if (parseFloat(this.value.replace(/,/g, '')) <= minimumPrice) {
						$(this).prop('disabled', true);
					} else {
						$(this).prop('disabled', false);
					}
				});
			} else {
				$(this).parent().parent().find('.property-feed__filter-minimum_price option').each(function() {
					if (parseFloat(this.value.replace(/,/g, '')) >= maximumPrice) {
						$(this).prop('disabled', true);
					} else {
						$(this).prop('disabled', false);
					}
				});
			}
		});
	})


	if($('.hero__gallery').length) {
		$('.hero__gallery').slick({
			dots: true,
			arrows: false,
			infinite: true,
			autoplay: true,
			autoplaySpeed: 5000,
			speed: 500,
			fade: true,
			cssEase: 'linear'
		});
	}

	// if($('.suburb-feed__btn').length) {
	// 	$('.suburb-feed__btn').click(function(e) {
	// 		e.preventDefault();

	// 		if (this.href.indexOf('?') !== -1) {
	// 			window.location.href = $('.suburb-feed .slick-slide.slick-current .suburb-feed__link').attr('href');
	// 		}

	// 	});
	// }

	if($('.property-feed__slider').length) {
		const swiper = new Swiper('.property-feed__slider', {
			autoplay: true,
			spaceBetween: 40,
			delay: 4500,
			slidesPerView: 3,
			slidesPerGroup: 1,
			loop: false,
			breakpoints: {
				0: {
					slidesPerView: 1,
				},
				1024: {
					slidesPerView: 3,
				}
			}
		});

		// !Jank.
		$('.property-feed__link.arrow img:first').click(function(e) {
			e.preventDefault();
			swiper.slidePrev();
		});

		$('.property-feed__link.arrow img:last').click(function(e) {
			e.preventDefault();
			swiper.slideNext();
		});
	}

	if($('.logo-list__logos').length && $('.logo-list__logos .logo-list__logo').length > 3 && window.innerWidth < 1024) {
		$('.logo-list__logos').slick({
			dots: false,
			arrows: true,
			infinite: true,
			autoplay: true,
			autoplaySpeed: 5000,
			prevArrow: $('.logo-list__group .prev'),
			nextArrow: $('.logo-list__group .next'),
		});

		$('.logo-list__logos').on('afterChange', function(event, slick, currentSlide, nextSlide){
			$('.logo-list__state-current').text(currentSlide + 1);
		});
	}

	if($('.step-list__steps').length && window.innerWidth < 1024) {
		$('.step-list__steps').slick({
			dots: false,
			arrows: true,
			infinite: true,
			autoplay: false,
			autoplaySpeed: 5000,
			prevArrow: $('.step-list__group .prev'),
			nextArrow: $('.step-list__group .next'),
		});

		$('.step-list__steps').on('afterChange', function(event, slick, currentSlide, nextSlide){
			$('.step-list__state-current').text(currentSlide + 1);
		});
	}


	if($('.suburb-properties-list__slider').length) {
		let loop = true;

		if($('.suburb-properties-list__slider .property-feed__property').length < 3) {
			loop = false;
		}

		const swiper = new Swiper('.suburb-properties-list__slider', {
			autoplay: true,
			spaceBetween: 40,
			delay: 4500,
			slidesPerView: 1,
			slidesPerGroup: 1,
			loop: loop,
			breakpoints: {
				1024: {
					slidesPerView: 3,
					slidesPerGroup: 1
				},

			}
		});
		$('.property-feed__group .prev').click(function() {
			swiper.slidePrev();
		})

		$('.suburb-properties-list__link.arrow,.property-feed__group .next').click(function(e) {
			e.preventDefault();
			swiper.slideNext();
		});

		swiper.on('slideChange', function() {
			$('.property-feed__state .property-feed__state-current').text(swiper.realIndex + 1);
		});

	}



	if($('.property-content__map #map').length) {
		const position = $('.property-content__map #map').data('position');
		mapboxgl.accessToken = 'pk.eyJ1IjoiYnJhbmRmb3JtcHJvamVjdHMiLCJhIjoiY2t3bHU3cDR3MDY0YjJvcWo0YnNpdmp4ZiJ9.pb7QU77jfVqc4Rz6k00sJw';

		const map = new mapboxgl.Map({
			container: 'map', // container ID
			style: 'mapbox://styles/brandformprojects/cl39mbj9o000f15pe5hutjfv5', // style URL
			center: position, // starting position [lng, lat]
			zoom: 12.5, // starting zoom
		});

		const marker = document.createElement('div');
		marker.className = 'marker';
		// set html
		marker.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="27.7" height="33.31" viewBox="0 0 27.7 33.31"><defs><style>.a{fill:none;}.b{clip-path:url(#a);}.c{clip-path:url(#b);}.d{clip-path:url(#c);}.e{fill:#fff;}.f{clip-path:url(#d);}.g{clip-path:url(#f);}.h{clip-path:url(#g);}</style><clipPath id="a"><rect class="a" width="27.7" height="26.54"/></clipPath><clipPath id="b"><path class="a" d="M13.46,21.83c-4.2,0-7.62-3.76-7.75-8.45H8.19v-.37H5.71c.05-4.76,3.5-8.61,7.75-8.61s7.7,3.84,7.75,8.61H18.73v.37h2.48c-.12,4.69-3.54,8.45-7.75,8.45m0-17.71a9,9,0,1,0,9,9,9,9,0,0,0-9-9"/></clipPath><clipPath id="c"><rect class="a" width="1600" height="3981" transform="translate(-1095.54 -1473.88)"/></clipPath><clipPath id="d"><path class="a" d="M10.46,9.21v-.1h2.78a4.68,4.68,0,0,1,1.35.18,2.459,2.459,0,0,1,.68.31,1.356,1.356,0,0,1,.72,1.36,1.287,1.287,0,0,1-.66,1,2.886,2.886,0,0,1-.77.37l-.11.03-.02.02.14.03a2.525,2.525,0,0,1,1.43.73,1.544,1.544,0,0,1,.43,1.21,1.749,1.749,0,0,1-1.34,1.58,3.318,3.318,0,0,1-1.08.19H10.43v-.1c.04,0,.07-.02.1-.02a.666.666,0,0,0,.49-.44,1.32,1.32,0,0,0,.06-.39V10.43a2,2,0,0,0-.09-.84.608.608,0,0,0-.23-.22.806.806,0,0,0-.33-.14Zm1.73,6.67a.747.747,0,0,0,.11.02,7.67,7.67,0,0,0,1.27.08,1.7,1.7,0,0,0,.67-.13,1.72,1.72,0,0,0,1-1.03,1.758,1.758,0,0,0,.08-.85,1.405,1.405,0,0,0-.34-.78,2.019,2.019,0,0,0-1.48-.69c-.41-.02-1.29,0-1.32,0v3.38Zm0-3.59a.838.838,0,0,1,.1.02,6.692,6.692,0,0,0,1,.04,1.84,1.84,0,0,0,.41-.04,1.4,1.4,0,0,0,1.14-.97,1.575,1.575,0,0,0,.08-.57,1.281,1.281,0,0,0-.21-.72,1.667,1.667,0,0,0-1.17-.74,6.177,6.177,0,0,0-1.36-.07v3.05Z"/></clipPath><clipPath id="f"><path class="a" d="M14.54,33.31l-4.15-6.92h8.3Z"/></clipPath><clipPath id="g"><rect class="a" width="1600" height="3981" transform="translate(-1094.3 -1474.17)"/></clipPath></defs><g class="b"><rect width="29.7" height="28.54" transform="translate(-1 -1)"/></g><g class="c"><g class="d"><rect class="e" width="20" height="20" transform="translate(3.46 3.12)"/></g></g><g class="f"><g class="d"><rect class="e" width="8.02" height="9" transform="translate(9.46 8.11)"/></g></g><g class="g"><g class="h"><rect width="10.31" height="8.92" transform="translate(9.39 25.39)"/></g></g></svg>';

		// add marker to map
		new mapboxgl.Marker(marker)
			.setLngLat(position)
			.addTo(map);


		map.scrollZoom.disable();
	}


	const updatePhoneInput = () => {
		$('.ginput_container_phone input').each(function() {
			$(this).attr('minlength', '6');
			$(this).on('input', function() {
				this.value = this.value.replace(/[^0-9]/g, '');
			});
		})
	}


	// arrangeFormInputs();
	updatePhoneInput();
	$(document).on('gform_post_render', function(event, formId) {
		// arrangeFormInputs();
		updatePhoneInput();
	});



	// BG Scroll Animation + General text fade in animations
	const sections = gsap.utils.toArray('section,.collection__container');
	// sections.forEach((section, i) => {
	// 	ScrollTrigger.create({
	// 		trigger: section,
	// 		start: `top top+=40%`,
	// 		end: 'bottom bottom',
	// 		// toggleActions: 'play none none reverse',
	// 		onUpdate: () => {
	// 			const isLight = section.classList.contains('light');
	// 			const isDark = section.classList.contains('dark');
	// 			if (isLight) {
	// 				$('body').removeClass('dark');
	// 				$('body').addClass('light');
	// 			} else if(isDark) {
	// 				$('body').removeClass('light');
	// 				$('body').addClass('dark');
	// 			} else {
	// 				$('body').removeClass('dark light');
	// 			}
	// 		}
	// 	})
	sections.forEach((section, i) => {
		let start = 'top top+=55%';
		let end = 'bottom bottom-=45%';

		if(section.offsetHeight < window.innerHeight / 3) {
			// start = `top bottom-=40%`;
			// end = `top top`;
		}

		let mm = gsap.matchMedia();

		mm.add("(max-width: 1023px)", () => {
			ScrollTrigger.create({
				trigger: section,
				start: 'top top+=70%',
				end: 'bottom bottom-=30%',
				onUpdate: () => {
					const isLight = section.classList.contains('light');
					const isDark = section.classList.contains('dark');

					if (isLight) {
						$('body').removeClass('dark');
						$('body').addClass('light');
					} else if(isDark) {
						$('body').removeClass('light');
						$('body').addClass('dark');
					} else {
						$('body').removeClass('dark light');
					}
				}
			})

			ScrollTrigger.create({
				trigger: section,
				start: 'top top+=70%',
				end: 'bottom bottom-=30%',
				onEnter: () => {
					$(section).addClass('in-view');
				},
				onEnterBack: () => {
					let query = $(section).next();
					if($(section).next().hasClass('border')) {
						query = $(section).next().next();
					}

					if(query.prop('tagName') === 'SECTION') {
						if(query.hasClass('white') && $(section).hasClass('white') || query.hasClass('light') && $(section).hasClass('white')) {
							// do nothing
						} else if(query.hasClass('light') && $(section).hasClass('light') || query.hasClass('light') && $(section).hasClass('light')) {
							// do nothing
						} else if(query.hasClass('dark') && $(section).hasClass('dark')) {
							// do nothing
						} else if(!$(query).hasClass('resources-post__content')) {
							query.removeClass('in-view');
						}

						$(section).addClass('in-view');
					}
				},
				onLeaveBack: () => {
					let query = $(section).prev();
					if($(section).prev().hasClass('border')) {
						query = $(section).prev().prev();
					}

					if(query.prop('tagName') === 'SECTION') {

						if(query.hasClass('white') && $(section).hasClass('white') || query.hasClass('light') && $(section).hasClass('white')) {
							// do nothing
						} else if(query.hasClass('light') && $(section).hasClass('light') || query.hasClass('white') && $(section).hasClass('light')) {
							// do nothing
						} else if(query.hasClass('dark') && $(section).hasClass('dark')) {
							// do nothing
						} else {
							$(section).removeClass('in-view');
						}

						$(section).prev().addClass('in-view');
					}

				},
				onLeave: () => {
					let query = $(section).next();
					if($(section).next().hasClass('border')) {
						query = $(section).next().next();
					}

					if(query.prop('tagName') === 'SECTION') {

						if(query.hasClass('white') && $(section).hasClass('white') || query.hasClass('light') && $(section).hasClass('white')) {
							// do nothing
						} else if(query.hasClass('light') && $(section).hasClass('light') || query.hasClass('white') && $(section).hasClass('light')) {
							// do nothing
						} else if(query.hasClass('dark') && $(section).hasClass('dark')) {
							// do nothing
						} else {
							$(section).removeClass('in-view');
						}

					}
					// $(section).removeClass('in-view');
				}
			})
		});

		mm.add("(min-width: 1024px)", () => {
			ScrollTrigger.create({
				trigger: section,
				start: `top top+=55%`,
				end: 'bottom bottom-=45%',
				onUpdate: () => {
					const isLight = section.classList.contains('light');
					const isDark = section.classList.contains('dark');

					if (isLight) {
						$('body').removeClass('dark');
						$('body').addClass('light');
					} else if(isDark) {
						$('body').removeClass('light');
						$('body').addClass('dark');
					} else {
						$('body').removeClass('dark light');
					}
				}
			})

			ScrollTrigger.create({
				trigger: section,
				start: start,
				end: end,
				onEnter: () => {
					$(section).addClass('in-view');
					if($(section).hasClass('resources-post__content') || $(section).find('.suburb-feed__feed').length) {
						$(section).addClass('freeze');
					}
				},
				onEnterBack: () => {
					let query = $(section).next();
					if($(section).next().hasClass('border')) {
						query = $(section).next().next();
					}

					if(query.prop('tagName') === 'SECTION') {
						if(query.hasClass('white') && $(section).hasClass('white') || query.hasClass('light') && $(section).hasClass('white')) {
							// do nothing
						} else if(query.hasClass('light') && $(section).hasClass('light') || query.hasClass('light') && $(section).hasClass('light')) {
							// do nothing
						} else if(query.hasClass('dark') && $(section).hasClass('dark')) {
							// do nothing
						} else {
							query.removeClass('in-view');
						}

						$(section).addClass('in-view');
					}
				},
				onLeaveBack: () => {
					let query = $(section).prev();
					if($(section).prev().hasClass('border')) {
						query = $(section).prev().prev();
					}

					if(query.prop('tagName') === 'SECTION') {

						if(query.hasClass('white') && $(section).hasClass('white') || query.hasClass('light') && $(section).hasClass('white')) {
							// do nothing
						} else if(query.hasClass('light') && $(section).hasClass('light') || query.hasClass('white') && $(section).hasClass('light')) {
							// do nothing
						} else if(query.hasClass('dark') && $(section).hasClass('dark')) {
							// do nothing
						} else {
							$(section).removeClass('in-view');
						}

						$(section).prev().addClass('in-view');
					}

				},
				onLeave: () => {
					let query = $(section).next();
					if($(section).next().hasClass('border')) {
						query = $(section).next().next();
					}


					if(query.prop('tagName') === 'SECTION') {
						if(query.hasClass('white') && $(section).hasClass('white') || query.hasClass('light') && $(section).hasClass('white')) {
							// do nothing
						} else if(query.hasClass('light') && $(section).hasClass('light') || query.hasClass('white') && $(section).hasClass('light')) {
							// do nothing
						} else if(query.hasClass('dark') && $(section).hasClass('dark')) {
							// do nothing
						} else {
							$(section).removeClass('in-view');
						}
					}
					// $(section).removeClass('in-view');
				}
			})
		});

		// ScrollTrigger.create({
		// 	trigger: section,
		// 	start: window.innerWidth >= 1024 ? 'top bottom-=41%' : 'top bottom-=25%',
		// 	end: 'bottom bottom',
		// 	onEnter: () => {
		// 		$(section).addClass('in-view');
		// 	}
		// })

	});

	if (gup('appraisal-form') === 'true') {
		$('.appraisal-form').addClass('active');
	}

	assignFormSubmitAutoDownloadEvent();

	/////////////////////////////////////////////////////////////////////////
	//// CSS variable setter
	webHeight();
	if(window.innerWidth >= 1024) {
		window.addEventListener('resize', function() {
			webHeight();
			// arrangeFormInputs();
		});
	}

});

function assignFormSubmitAutoDownloadEvent() {
	jQuery(document).on('gform_confirmation_loaded', function(event, formId){

		if (formId === 11 || formId === 12) {
			var download_button_elem = jQuery('.popup-form.active a[download]');

			// trigger download button click after form submit
			if (download_button_elem[0]) {
				download_button_elem[0].click();
			}
		}
	});
}

function gup(name) {
	name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
	var regexS = '[\\?&]' + name + '=([^&#]*)';
	var regex = new RegExp(regexS);
	var results = regex.exec(window.location.href);
	if (results == null) return false;
	else return results[1];
}

// * Safari height issues for iPad and iPhones
function webHeight() {
	const doc = document.documentElement;
	const headerHeight = $('header').outerHeight(true);
	doc.style.setProperty('--header-height', `${headerHeight}px`);
	doc.style.setProperty('--vp-height', `${window.innerHeight}px`);
	doc.style.setProperty('--vp-width', `${window.innerWidth}px`);
}

function setCookie(name,value,days) {
	var expires = "";
	if (days) {
			var date = new Date();
			date.setTime(date.getTime() + (days*24*60*60*1000));
			expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');

	for(var i=0;i < ca.length;i++) {
			var c = ca[i];
			while (c.charAt(0)==' ') c = c.substring(1,c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
	}
	return null;
}
function eraseCookie(name) {
	document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}


function getCursorPos(e, parent) {
	var parentOffset = $(parent).offset();
	var relX = e.pageX - parentOffset.left;
	var relY = e.pageY - parentOffset.top;
	return {x: relX, y: relY};
}


/* function arrangeFormInputs() {
	const parent = $('#field_7_6 .ginput_container');
	const inputs = $('#field_7_11,#field_7_13');
	let offset = window.innerWidth >= 376 ? 30 : 0;


	inputs[0].style.top = parent.parent()[0].offsetTop + parent[0].offsetHeight + offset + 'px';
	inputs[1].style.top = inputs[0].offsetTop + inputs[0].offsetHeight + 'px';

	// $('#gform_wrapper_7 .gform_footer').css('margin-top', inputs[1].offsetHeight - $('#gform_wrapper_7 .gform_footer').height() + offset + 'px');
	// $('#gform_wrapper_7 .gform_footer').css('margin-top', 0 + 'px');



	const field_7_13 = $('#field_7_13');
	const field_7_8 = $('#field_7_8');
	const field_7_8_height = field_7_8.height();
	const field_7_13_bottom = field_7_13.offset().top + field_7_13.height();
	const field_7_8_bottom = field_7_8.offset().top + field_7_8_height;

	if(field_7_13_bottom > field_7_8_bottom) {
		field_7_8.height(field_7_13_bottom - field_7_8.offset().top);
	}

} */

function sortPrices() {
	const minPriceSelect = $('.property-feed__filter-minimum_price select');
	const maxPriceSelect = $('.property-feed__filter-maximum_price select');
	// get $('.property-feed__list .property-feed__property') elements that doesns't have display 'none';
	const properties = $('.property-feed__list .property-feed__property').filter(function() {
		return $(this).css('display') !== 'none';
	});

	// console.log(properties)

	// Find all property elements and extract the price data
	let prices = properties.map(function() {
			return parseInt($(this).data('data').price.replace(/[^0-9]/g, ''));
	}).get();

	prices = [...new Set(prices)].sort((a, b) => a - b);

	let formattedPrices = [];

	const smallestPrice = prices[0];
	const largestPrice = prices[prices.length - 1];

	let ints = [];

	if (smallestPrice < 50000) {
		for (let i = 50; i < 800; i += 25) {
			ints.push(i)
		}
		for (let i = 900; i <= 1000; i += 50) {
			ints.push(i)
		}

		for (let i = 1100; i <= 2000; i += 100) {
			ints.push(i)
		}

		for (let i = 2500; i <= 15000; i += 500) {
			ints.push(i)
		}

		// let j = 40000;
		// for (let i = 10000; i <= 150000; i += j) {
		// 	if (i === 90000) {
		// 		ints.push(100000)
		// 		j = 50000;
		// 		i = 100000;
		// 	} else {
		// 		ints.push(i)
		// 	}
		// }

	} else {
		ints = [100000, 200000, 300000, 400000, 500000, 600000, 700000, 800000, 900000, 1000000,
			1500000, 2000000, 2500000, 3000000, 3500000, 4000000, 4500000, 5000000, 5500000, 6000000,
			6500000, 7000000, 7500000, 8000000, 8500000, 9000000, 9500000, 10000000]
	}

	ints.forEach(function(int) {
		formattedPrices.push('$' + int.toLocaleString());
	});

	minPriceSelect.empty().append($('<option>', { value: 'all', text: 'All' }));
	maxPriceSelect.empty().append($('<option>', { value: 'all', text: 'All' }));
	minPriceSelect.val('all');
	maxPriceSelect.val('all');

	formattedPrices.forEach(function(price) {
		minPriceSelect.append($('<option>', { value: price.slice(1), text: price }));
		maxPriceSelect.append($('<option>', { value: price.slice(1), text: price }));
	});

	// $('.property-feed__filter-minimum_price select').trigger('change');
}

function sortProperties(selectedValue) {
  const properties = $('.property-feed__list .property-feed__property').filter(function() {
		return $(this).css('display') !== 'none';
	});

  switch(selectedValue) {
    case 'newest':
      properties.sort(function(a, b) {
        return parseInt($(b).data('data').date) - parseInt($(a).data('data').date);
      });
      break;
    case 'oldest':
      properties.sort(function(a, b) {
        return parseInt($(a).data('data').date) - parseInt($(b).data('data').date);
      });
      break;
    case 'price-low':
      properties.sort(function(a, b) {
        return parseInt($(a).data('data').price.replace(/[^0-9]/g, '')) - parseInt($(b).data('data').price.replace(/[^0-9]/g, ''));
      });
      break;
    case 'price-high':
      properties.sort(function(a, b) {
        return parseInt($(b).data('data').price.replace(/[^0-9]/g, '')) - parseInt($(a).data('data').price.replace(/[^0-9]/g, ''));
      });
      break;
    default:
		properties.sort(function(a, b) {
			return parseInt($(b).data('data').date) - parseInt($(a).data('data').date);
		  });
      return;
  }
  properties.each(function(index) {
    $(this).css('order', index);
  });

	// if (window.location.href.indexOf('#') > -1) {
	// 	setTimeout(function() {
	// 		window.scrollTo(0, 0);

	// 		// $('html, body').animate({
	// 		// 	scrollTop: $(window.location.hash).offset().top - $('header').outerHeight()
	// 		// }, 1000);
	// 	}, 1);
	// }
}

var target = window.location.hash;

window.location.hash = "";

$(window).on('load', function() {
	setTimeout(function() {
		if ($(target).length) {
			if ($(target).height() > $(window).height() - $('header').outerHeight()) {
				$('html, body').animate({
					scrollTop: $(target).offset().top - $('header').outerHeight()
				}, 700, 'swing', function () {});
			} else {
				$('html, body').animate({
					scrollTop: window.innerWidth >= 1024 ? $(target).offset().top - ((window.innerHeight - $(target).outerHeight()) / 2) : $(target).offset().top - $('header').outerHeight()
				}, 700, 'swing', function () {});
			}

		}
	},100);
});


